import React, { useState, useEffect }  from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import './RSVP.css';
import './Global.css';

const RSVP = () => {
    const [loading, setLoading] = useState(false);
    const [guestName, setGuestName] = useState('');
    const [attendance, setAttendance] = useState('');
    const [guestsNumber, setGuestsNumber] = useState(1);
    const [guestNames, setGuestNames] = useState(['']); // Array to store names for each guest
    const [dietaryRequirements, setDietaryRequirements] = useState([]); // Array to store dietary requirements for each guest

    useEffect(() => {
      const fetchData = async () => {
        const response = await fetch('https://weddingnnjn.azurewebsites.net/api/start');
        //const response = await fetch('http://localhost:7071/api/start');
        console.log(response);
      };
      fetchData();
    }, []);

  
    const handleGuestNumberChange = (event) => {
      setGuestsNumber(parseInt(event.target.value))
      setGuestNames([guestNames[0]]);
      setDietaryRequirements([dietaryRequirements[0]]);
    };
  
    const handleGuestNameChange = (index, event) => {
      console.log(`handleGuestNameChange called with index: ${index} and value: ${event.target.value}`);
      const newGuestNames = [...guestNames];
      newGuestNames[index] = event.target.value;
      setGuestNames(newGuestNames);
    };
  
    const handleDietaryRestrictionChange = (index, event) => {
      const newDietaryRequirements = [...dietaryRequirements];
      newDietaryRequirements[index] = event.target.value;
      setDietaryRequirements(newDietaryRequirements);
    };
  
    const handleSubmit = async (event) => {
      event.preventDefault();
      setLoading(true);
  
      // Prepare the data object
      const data = {
        guestName,
        attendance,
        guestsNumber,
        guests: guestNames.map((name, index) => ({
          name,
          dietaryRequirements: dietaryRequirements[index] || ''
        }))
      };

      console.log('Data to be submitted:', data);

      // Send the data to the Azure Function
      try {
        const response = await fetch('https://weddingnnjn.azurewebsites.net/api/rsvp', {
        //const response = await fetch('http://localhost:7071/api/rsvp', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
        setLoading(false);
        console.log(response.json());

        if (response.ok) {
          alert("Thank you for your RSVP!");
          // Clear the form after submission
          setGuestName('');
          setAttendance('');
          setGuestsNumber(1);
          setGuestNames(['']);
          setDietaryRequirements([]);
        } else {
          console.log('Failed to submit form:', response);
          alert("There was an issue with your RSVP. Please try again. If the issue persists please contact Rebecca or Nathan.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("An error occurred. Please try again.");
      }
    };

    return (
        <div class="rsvp text-center container-styling">
          <div className="title-padding top-header">
            <h1>RSVP</h1>
          </div>
          <div className="container py-5">
            <h2>Rebecca and Nathan's Wedding</h2>
            <br />
            <p>We can't wait to celebrate with you! Please RSVP by <b>January 31st 2025.</b></p>
            <p> Please note: To ensure we can accommodate everyone, we kindly request that you RSVP only for the guests specified in the accompanying invitation message you received </p>
            <br />
            <Form onSubmit={handleSubmit}>
              {/* Guest Name */}
              <Form.Group controlId="guestName" className="form-spacing">
                <Form.Label>Your Name (Guest 1):</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Guest 1 Name"
                  value={guestName}
                  onChange={(e) => {
                    setGuestName(e.target.value);
                    handleGuestNameChange(0, e);
                  }}
                  required
                />
              </Form.Group>

      {/* Attendance */}
              <Form.Group className="form-spacing">
                <Form.Label>Will you be attending?</Form.Label>
                <div key="inline-radio">
                  <Form.Check
                    inline
                    label="Yes"
                    name="attendance"
                    required="required"
                    type="radio"
                    id="yesRadio"
                    value="yes"
                    checked={attendance === 'yes'}
                    onChange={(e) => setAttendance(e.target.value)}
                    feedback="Please select an option."
                  />
                  <Form.Check
                    inline
                    label="No"
                    name="attendance"
                    required="required"
                    type="radio"
                    id="noRadio"
                    value="no"
                    checked={attendance === 'no'}
                    onChange={(e) => setAttendance(e.target.value)}
                    feedback="Please select an option."
                  />
                </div>
              </Form.Group>

              {/* Number of Guests (if attending) */}
              {attendance === 'yes' && (
                <Form.Group controlId="guestsNumber" className="form-spacing">
                  <Form.Label>Number of Guests Attending (including yourself):</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    value={guestsNumber}
                    onChange={handleGuestNumberChange}
                    required
                  />
                </Form.Group>
              )}

              {/* Guest Names (if attending and multiple guests) */}
              {attendance === 'yes' &&
                guestsNumber > 1 &&
                Array.from({ length: guestsNumber-1 }, (_, index) => (
                  <Form.Group key={`guestName-${index+1}`} className="form-spacing">
                    <Form.Label>Guest {index+2} Name:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={`Guest ${index + 2} Name`}
                      value={guestNames[index+1] || ''} // Access corresponding guest name based on index
                      onChange={(e) => handleGuestNameChange(index+1, e)}
                      required
                    />
                  </Form.Group>
                ))}

              {/* Dietary Requirements (optional) */}
              {attendance === 'yes' &&
                guestsNumber > 0 &&
                Array.from({ length: guestsNumber }, (_, index) => (
                  <div key={`dietaryRequirements-${index}`} className="form-spacing">
                    <Form.Label>
                      {index === 0
                        ? `${guestName}'s Dietary Requirements (optional):`
                        : guestNames[index]
                          ? `${guestNames[index]}'s Dietary Requirements (optional):`
                          : 'Guest Dietary Requirements (optional):'}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. Vegeterian, Vegan, Gluten-free etc"
                      value={dietaryRequirements[index] || ''} // Access corresponding dietary restriction based on index
                      onChange={(e) => handleDietaryRestrictionChange(index, e)}
                    />
                  </div>
                ))}

                {loading ? (
                  <Button variant="primary" disabled className="submit-button">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </Button>
                ) : (
                  <Button variant="primary" type="submit" className="submit-button">
                    Submit RSVP
                  </Button>
                )}
            </Form>
          </div>
        </div>
    );
}

export default RSVP;